// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const ContentZone = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 56" fill="none" {...props}>
      <path
        d="M28.7266 56C44.1905 56 56.7266 43.464 56.7266 28C56.7266 12.536 44.1905 0 28.7266 0C13.2626 0 0.726562 12.536 0.726562 28C0.726562 43.464 13.2626 56 28.7266 56Z"
        fill="#DA2FE9"
      />
      <path
        opacity="0.34"
        d="M44.5292 15.0898H42.1511C42.4426 14.5144 42.5347 13.8777 42.4273 13.2717C42.2892 12.5506 41.8749 11.8679 41.2229 11.4229C39.9111 10.5254 38.116 10.8552 37.2185 12.167L35.2086 15.0898H15.3095C13.3456 15.0898 11.75 16.6854 11.75 18.6492V36.3698C11.75 38.3336 13.3456 39.9292 15.3095 39.9292H25.2821V44.3402H21.9911C21.4311 44.3402 20.9785 44.7928 20.9785 45.3528C20.9785 45.9128 21.4311 46.3654 21.9911 46.3654H38.5379C39.0979 46.3654 39.5506 45.9128 39.5506 45.3528C39.5506 44.7928 39.0979 44.3402 38.5379 44.3402H35.247V39.9292H44.5369C46.5007 39.9292 48.0963 38.3336 48.0963 36.3698V18.6492C48.0963 16.6854 46.5007 15.0898 44.5369 15.0898H44.5292Z"
        fill="#321A75"
      />
      <path
        d="M36.997 43.0813H33.706V35.1416H23.7411V43.0813H20.4501C19.8901 43.0813 19.4375 43.5339 19.4375 44.0939C19.4375 44.6539 19.8901 45.1065 20.4501 45.1065H36.997C37.557 45.1065 38.0095 44.6539 38.0095 44.0939C38.0095 43.5339 37.557 43.0813 36.997 43.0813Z"
        fill="#CAD0D7"
      />
      <path
        d="M42.9903 13.8389H13.7782C11.8124 13.8389 10.2188 15.4325 10.2188 17.3983V35.1112C10.2188 37.077 11.8124 38.6706 13.7782 38.6706H42.9903C44.9561 38.6706 46.5497 37.077 46.5497 35.1112V17.3983C46.5497 15.4325 44.9561 13.8389 42.9903 13.8389Z"
        fill="white"
      />
      <path
        d="M14.6134 14.7441H42.1608C43.9175 14.7441 45.3444 16.171 45.3444 17.9277V33.9606H11.4375V17.9277C11.4375 16.171 12.8644 14.7441 14.6211 14.7441H14.6134Z"
        fill="url(#paint0_linear_3436_157666)"
      />
      <path
        d="M21.9688 26.3354V26.1973C21.9688 25.672 21.5429 25.2461 21.0175 25.2461H15.9392C15.4138 25.2461 14.9879 25.672 14.9879 26.1973V26.3354C14.9879 26.8608 15.4138 27.2866 15.9392 27.2866H21.0175C21.5429 27.2866 21.9688 26.8608 21.9688 26.3354Z"
        fill="url(#paint1_linear_3436_157666)"
      />
      <path
        d="M28.3906 29.7876V29.6495C28.3906 29.1241 27.9647 28.6982 27.4394 28.6982H15.9479C15.4225 28.6982 14.9967 29.1241 14.9967 29.6495V29.7876C14.9967 30.3129 15.4225 30.7388 15.9479 30.7388H27.4394C27.9647 30.7388 28.3906 30.3129 28.3906 29.7876Z"
        fill="url(#paint2_linear_3436_157666)"
      />
      <path
        d="M40.4344 14.1841L32.7171 25.4225H32.7094L30.3774 26.1282L28.3138 26.7419L28.1374 24.548L27.9609 22.1699L27.984 22.1392L35.6859 10.9239C36.5834 9.61208 38.3785 9.28222 39.6902 10.1798C40.3423 10.6247 40.7566 11.3074 40.8946 12.0285C41.025 12.7573 40.887 13.5321 40.4344 14.1841Z"
        fill="#FFB103"
      />
      <path
        opacity="0.53"
        d="M32.7171 25.4229H32.7094L30.3774 26.1287L28.3138 26.7424L28.1374 24.5484L27.9609 22.1703L27.984 22.1396C28.8892 22.4695 31.1829 23.4591 32.7171 25.4229Z"
        fill="white"
      />
      <path
        d="M30.3651 26.1203L28.3016 26.734L28.1328 24.54C28.5394 24.6244 28.969 24.8085 29.3602 25.077C29.7898 25.3762 30.135 25.7368 30.3651 26.1126V26.1203Z"
        fill="#7443D9"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3436_157666"
          x1="11.4298"
          y1="24.3562"
          x2="45.3444"
          y2="24.3562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AEFFF3" />
          <stop offset="1" stopColor="#B3DCF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3436_157666"
          x1="14.9879"
          y1="26.274"
          x2="21.9688"
          y2="26.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5382ED" />
          <stop offset="1" stopColor="#576CE7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3436_157666"
          x1="14.989"
          y1="29.7185"
          x2="28.3906"
          y2="29.7185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5382ED" />
          <stop offset="1" stopColor="#576CE7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
